<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    v-loading.fullscreen.lock="mainLoader"
    class="signup-ngs-page page"
    element-loading-background="rgba(255, 255, 255, 0.8)"
  >
    <div :class="`signup-ngs-page__header step-${currentStep}`">
      <div class="header__content__image"></div>
      <div class="header__content__bg"></div>
      <div class="header__content container">
        <el-row>
          <el-col
            :md="24"
            :lg="12"
          >
            <div
              id="main-content"
              class="header__content__wrapper"
            >
              <h2
                class="header__title"
                v-html="heroText"
              ></h2>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="signup-ngs-page__body">
      <div class="container">
        <el-row>
          <el-col>
            <!-- Step 0 Intro -->
            <div
              v-show="currentStep === 0"
              class="body__content"
            >
              <h1 class="body__title">
                Thanks for your interest in becoming a service on CWB
              </h1>

              <p
                class="se-body-l-screen mb-4"
              >
                The application should take no more than 15 minutes. We’ll ask you about your business experience, what support you can offer and why you want to become a service. All fields are mandatory unless noted as optional.
              </p>

              <!--p
                class="se-body-l-screen-medium mb-4"
              >We are currently seeking services across mainland Europe to align with the priority countries outlined in the 'Trading Nation' Export Growth Plan in the following sectors:
                <ul class="sectors-list">
                  <li>Food &amp; Drink</li>
                  <li>Medtech/Health tech</li>
                  <li>AI and Edtech (the latter also in the US)</li>
                </ul>
              </p-->

              <p
                class="se-body-l-screen mb-4"
              >
                If successful, all the information you provide will be publicly visible on your profile, except for your contact details.
              </p>

              <div class="submit-button-wrapper">
                <el-button
                  type="primary"
                  native-type="submit"
                  @click="gotoStep(1)"
                >
                  Start application
                </el-button>
              </div>
            </div>
            <!-- Step 0 Intro End -->

            <!-- Step 1 Personal and Company details -->
            <div
              v-show="currentStep === 1"
              class="body__content"
            >
              <validation-errors
                v-if="validationErrors.length && currentStep === 1"
                :errors="validationErrors"
              ></validation-errors>

              <el-form
                id="step1Form"
                ref="step1Form"
                :model="step1Form.form"
                :rules="step1FormRules"
                autocomplete="false"
                @submit.native.prevent
                @validate="handleFormFieldInput('step1Form')"
              >
                <h1 class="se-heading-m step-title">
                  <span class="color-primary">Step {{ currentStep }} / 3</span>
                  Personal and contact details
                </h1>

                <p class="se-body-l-screen mb-4">
                  This information will be visible to other members on the network
                </p>

                <div class="step-hr"></div>

                <el-row>
                  <el-col
                    :md="24"
                    :lg="16"
                    :xl="14"
                  >
                    <label for="first_name">
                      First name
                      <span
                        class="sr-only"
                        aria-live="polite"
                        :hidden="!hasInlineValidationErrorFor('step1Form','first_name')"
                        v-text="getInlineValidationErrorFor('step1Form','first_name')"
                      ></span>
                    </label>
                    <span class="is-custom-asterisk">*</span><br />
                    <el-form-item prop="first_name">
                      <el-input
                        id="first_name"
                        v-model="step1Form.form.first_name"
                        maxlength="64"
                        autocomplete="false"
                        label="Please enter your first name in this field"
                        aria-required="true"
                        @blur="step1Form.form.first_name = step1Form.form.first_name.trim()"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col
                    :md="24"
                    :lg="16"
                    :xl="14"
                  >
                    <label for="last_name">
                      Last name
                      <span
                        class="sr-only"
                        aria-live="polite"
                        :hidden="!hasInlineValidationErrorFor('step1Form','last_name')"
                        v-text="getInlineValidationErrorFor('step1Form','last_name')"
                      ></span>
                    </label>
                    <span class="is-custom-asterisk">*</span><br />
                    <el-form-item prop="last_name">
                      <el-input
                        id="last_name"
                        v-model="step1Form.form.last_name"
                        maxlength="64"
                        autocomplete="false"
                        label="Please enter your last name in this field"
                        aria-required="true"
                        @blur="step1Form.form.last_name = step1Form.form.last_name.trim()"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col
                    :md="24"
                    :lg="16"
                    :xl="14"
                  >
                    <label for="email">
                      Email address<span class="is-custom-asterisk">*</span><br />
                      <p class="el-form-item__info">This will not be displayed on your profile</p>
                      <span
                        class="sr-only"
                        aria-live="polite"
                        :hidden="!hasInlineValidationErrorFor('step1Form','email')"
                        v-text="getInlineValidationErrorFor('step1Form','email')"
                      ></span>
                    </label>
                    <el-form-item
                      prop="email"
                      class="is-no-asterisk"
                    >
                      <el-input
                        id="email"
                        v-model="step1Form.form.email"
                        type="email"
                        autocomplete="false"
                        label="Please enter your desired email address in this field"
                        aria-required="true"
                        @blur="step1Form.form.email = step1Form.form.email.trim()"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col
                    :md="24"
                    :lg="16"
                    :xl="14"
                  >
                    <label for="email_confirmation">Confirm email address
                      <span
                        class="sr-only"
                        aria-live="polite"
                        :hidden="!hasInlineValidationErrorFor('step1Form','email_confirmation')"
                        v-text="getInlineValidationErrorFor('step1Form','email_confirmation')"
                      ></span>
                    </label>
                    <span class="is-custom-asterisk">*</span><br />
                    <el-form-item prop="email_confirmation">
                      <el-input
                        id="email_confirmation"
                        v-model="step1Form.form.email_confirmation"
                        type="email"
                        autocomplete="false"
                        label="Please confirm the desired email address in this field"
                        aria-required="true"
                        @blur="step1Form.form.email_confirmation = step1Form.form.email_confirmation.trim()"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>

                <div class="step-hr"></div>

                <h2 class="se-heading-m mb-2">
                  Organisation details
                </h2>

                <el-row>
                  <el-col
                    :md="24"
                    :lg="16"
                    :xl="14"
                  >
                    <label for="organisation_name">
                      Organisation name<span class="is-custom-asterisk">*</span><br />
                      <span
                        class="sr-only"
                        aria-live="polite"
                        :hidden="! hasInlineValidationErrorFor('step1Form','organisation_name')"
                        v-text="getInlineValidationErrorFor('step1Form','organisation_name')"
                      ></span>
                    </label>
                    <el-form-item
                      prop="organisation_name"
                      class="is-no-asterisk"
                    >
                      <el-input
                        id="organisation_name"
                        v-model="step1Form.form.organisation_name"
                        maxlength="20"
                        autocomplete="false"
                        label="Please enter your organisation name in this field"
                        aria-required="true"
                        @blur="step1Form.form.organisation_name = step1Form.form.organisation_name.trim()"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col
                    :md="24"
                    :lg="16"
                    :xl="14"
                  >
                    <label for="role">
                      Your role at the organisation<span class="is-custom-asterisk">*</span><br />
                      <span
                        class="sr-only"
                        aria-live="polite"
                        :hidden="! hasInlineValidationErrorFor('step1Form','role')"
                        v-text="getInlineValidationErrorFor('step1Form','role')"
                      ></span>
                    </label>
                    <el-form-item
                      prop="role"
                      class="is-no-asterisk"
                    >
                      <el-input
                        id="role"
                        v-model="step1Form.form.role"
                        maxlength="20"
                        autocomplete="false"
                        label="Please enter your organisation name in this field"
                        aria-required="true"
                        @blur="step1Form.form.role = step1Form.form.role.trim()"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col
                    :md="24"
                    :lg="16"
                    :xl="14"
                  >
                    <label for="post_code">
                      Post code
                      <span
                        class="sr-only"
                        aria-live="polite"
                        :hidden="! hasInlineValidationErrorFor('step1Form','post_code')"
                        v-text="getInlineValidationErrorFor('step1Form','post_code')"
                      ></span>
                    </label>
                    <span class="is-custom-asterisk">*</span><br />
                    <el-form-item prop="post_code">
                      <div class="d-flex">
                        <el-input
                          id="post_code"
                          v-model="step1Form.form.post_code"
                          class="half-flex-content"
                          maxlength="10"
                          autocomplete="false"
                          label="Please enter organisation post code in this field"
                          aria-required="true"
                          @blur="step1Form.form.post_code = step1Form.form.post_code.trim()"
                          @input="step1Form.disableAddressLookup = false"
                          @keyup.enter.native="onFindAddress($event)"
                        />

                        <div class="mr-3"></div>

                        <el-form-item class="half-flex-content">
                          <el-button
                            size="medium"
                            :disabled="step1Form.disableAddressLookup || step1Form.form.post_code.trim().length == 0"
                            @click="onFindAddress($event)"
                          >
                            Find address
                          </el-button>
                        </el-form-item>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>

                <div
                  v-if="step1Form.addressesLoading"
                  v-loading="step1Form.addressesLoading"
                  class="address-loader"
                ></div>

                <el-row v-if="step1Form.availableMailingAddresses.length > 0">
                  <el-col
                    :md="24"
                    :lg="16"
                    :xl="14"
                  >
                    <el-form-item>
                      <template slot="label">
                        <span aria-hidden="true">Addresses Found</span>
                        <span class="sr-only">Please select an address</span>
                        <span
                          class="sr-only"
                          aria-live="polite"
                          :hidden="!hasInlineValidationErrorFor('step1Form','available_mailing_addresses')"
                          v-text="getInlineValidationErrorFor('step1Form','available_mailing_addresses')"
                        ></span>
                      </template>
                      <single-select
                        v-model="step1Form.selectedAvailableMailingAddress"
                        :options="step1Form.availableMailingAddresses"
                        name="available_mailing_addresses"
                        @input="onAvailableMailingAddressSelected($event)"
                      ></single-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col
                    :md="24"
                    :lg="16"
                    :xl="14"
                  >
                    <label for="address_1">
                      Address line 1
                      <span
                        class="sr-only"
                        aria-live="polite"
                        :hidden="! hasInlineValidationErrorFor('step1Form','address_1')"
                        v-text="getInlineValidationErrorFor('step1Form','address_1')"
                      ></span>
                    </label>
                    <span class="is-custom-asterisk">*</span><br />
                    <el-form-item prop="address_1">
                      <el-input
                        id="address_1"
                        v-model="step1Form.form.address_1"
                        maxlength="255"
                        autocomplete="false"
                        label="Please enter organisation address line 1 in this field"
                        aria-required="true"
                        @blur="step1Form.form.address_1 = step1Form.form.address_1.trim()"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col
                    :md="24"
                    :lg="16"
                    :xl="14"
                  >
                    <label for="address_2">
                      Address line 2
                      <span
                        class="sr-only"
                        aria-live="polite"
                        :hidden="! hasInlineValidationErrorFor('step1Form','address_2')"
                        v-text="getInlineValidationErrorFor('step1Form','address_2')"
                      ></span>
                    </label>
                    <el-form-item prop="address_2">
                      <el-input
                        id="address_2"
                        v-model="step1Form.form.address_2"
                        maxlength="255"
                        autocomplete="false"
                        label="Please enter organisation address line 2 in this field"
                        @blur="step1Form.form.address_2 = step1Form.form.address_2.trim()"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col
                    :md="24"
                    :lg="16"
                    :xl="14"
                  >
                    <label for="town">
                      Town or city
                      <span
                        class="sr-only"
                        aria-live="polite"
                        :hidden="! hasInlineValidationErrorFor('step1Form','town')"
                        v-text="getInlineValidationErrorFor('step1Form','town')"
                      ></span>
                    </label>
                    <span class="is-custom-asterisk">*</span><br />
                    <el-form-item prop="town">
                      <el-input
                        id="town"
                        v-model="step1Form.form.town"
                        maxlength="100"
                        autocomplete="false"
                        label="Please enter organisation town or city in this field"
                        aria-required="true"
                        @blur="step1Form.form.town = step1Form.form.town.trim()"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col
                    :md="24"
                    :lg="16"
                    :xl="14"
                  >
                    <label for="county">
                      County
                      <span
                        class="sr-only"
                        aria-live="polite"
                        :hidden="! hasInlineValidationErrorFor('step1Form','county')"
                        v-text="getInlineValidationErrorFor('step1Form','county')"
                      ></span>
                    </label>
                    <span class="is-custom-asterisk">*</span><br />
                    <el-form-item prop="county">
                      <el-input
                        id="county"
                        v-model="step1Form.form.county"
                        maxlength="100"
                        autocomplete="false"
                        label="Please enter mailing county in this field"
                        @blur="step1Form.form.county = step1Form.form.county.trim()"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col
                    :md="24"
                    :lg="16"
                    :xl="14"
                  >
                    <label for="contact_number">
                      Contact number<br />
                      <span
                        class="sr-only"
                        aria-live="polite"
                        :hidden="! hasInlineValidationErrorFor('step1Form','contact_number')"
                        v-text="getInlineValidationErrorFor('step1Form','contact_number')"
                      ></span>
                    </label>
                    <el-form-item
                      prop="contact_number"
                      class="is-no-asterisk"
                    >
                      <el-input
                        id="contact_number"
                        v-model="step1Form.form.contact_number"
                        class="w-lg-75"
                        maxlength="20"
                        autocomplete="false"
                        label="Please enter your organisation, contact number in this field"
                        aria-required="true"
                        @blur="step1Form.form.contact_number = step1Form.form.contact_number.trim()"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col
                    :md="24"
                    :lg="16"
                    :xl="14"
                  >
                    <label for="organisation_email">
                      Organisation email address<br />
                      <span
                        class="sr-only"
                        aria-live="polite"
                        :hidden="!hasInlineValidationErrorFor('step1Form','organisation_email')"
                        v-text="getInlineValidationErrorFor('step1Form','organisation_email')"
                      ></span>
                    </label>
                    <el-form-item
                      prop="organisation_email"
                      class="is-no-asterisk"
                    >
                      <el-input
                        id="organisation_email"
                        v-model="step1Form.form.organisation_email"
                        type="email"
                        autocomplete="false"
                        label="Please enter your desired email address in this field"
                        aria-required="true"
                        @blur="step1Form.form.organisation_email = step1Form.form.organisation_email.trim()"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col
                    :md="24"
                    :lg="16"
                    :xl="14"
                  >
                    <label for="organisation_website_address">
                      Website address<br />
                      <p class="el-form-item__info">Please ensure your website address begins with https://</p>
                      <span
                        class="sr-only"
                        aria-live="polite"
                        :hidden="!hasInlineValidationErrorFor('step1Form','website_address')"
                        v-text="getInlineValidationErrorFor('step1Form','website_address')"
                      ></span>
                    </label>
                    <el-form-item
                      prop="website_address"
                    >
                      <el-input
                        id="organisation_website_address"
                        v-model="step1Form.form.website_address"
                        type="email"
                        autocomplete="false"
                        label="Please enter your desired website address in this field"
                        aria-required="true"
                        @blur="step1Form.form.website_address = step1Form.form.website_address.trim()"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>

                <div class="step-hr mt-4"></div>

                <h2 class="se-heading-m mb-4">
                  Upload an organisation profile photo - Optional
                </h2>

                <div
                  v-if="step1Form.avatarFile"
                  class="uploaded-file d-flex"
                >
                  <el-avatar
                    shape="circle"
                    :size="140"
                    :src="avatarUrl"
                    alt="Organisation Profile picture"
                    class="step-1-avatar"
                  ></el-avatar>

                  <div class="flex-fill">
                    <div class="upload-actions">
                      <el-upload
                        ref="upload"
                        action=""
                        :multiple="false"
                        :drag="true"
                        list-type="picture-card"
                        class="selected-upload"
                        :auto-upload="false"
                        :on-change="onFileChange"
                      >
                        <div slot="default">
                          <el-button class="replace-button">
                            Replace
                          </el-button>
                        </div>

                        <div
                          v-if="step1Form.avatarFile"
                          slot="file"
                          slot-scope="{file}"
                        >
                        </div>
                      </el-upload>
                      <span
                        class="remove-file-link"
                        @click="removeSelectedAvatar"
                      >Remove</span>
                    </div>
                  </div>
                </div>

                <el-upload
                  ref="upload"
                  action=""
                  :multiple="false"
                  :drag="true"
                  list-type="picture-card"
                  class="initial-upload"
                  :class="{ 'upload-show': step1Form.avatarFile }"
                  :auto-upload="false"
                  :on-change="onFileChange"
                >
                  <div slot="default">
                    <div class="se-file-upload">
                      <img
                        src="../../../static/img/file-drag-drop.svg"
                        alt="Drag & drop files here"
                        class="drag-drop-img"
                      />
                      <span class="or-text se-body-s-screen-16 m-4">or</span>
                      <el-button class="browse-button">
                        Browse files
                      </el-button>
                    </div>
                  </div>

                  <div
                    v-if="step1Form.avatarFile"
                    slot="file"
                  >
                  </div>
                </el-upload>
              </el-form>

              <div class="submit-button-wrapper mt-4">
                <el-button
                  type="primary"
                  native-type="submit"
                  @click="submitStep1Form"
                >
                  Continue
                </el-button>
              </div>
            </div>
            <!-- Step 1 Personal and Company details End -->
            <!-- Step 2 Plans and experience -->
            <div
              v-show="currentStep === 2"
              class="body__content"
            >
              <el-button
                type="text"
                size="medium"
                class="step-goback-button align-self-start color-black"
                @click="gotoStep(1)"
              >
                <span aria-hidden="true">&lt; Back</span>
                <span class="sr-only">Go back a step</span>
              </el-button>

              <validation-errors
                v-if="validationErrors.length && currentStep === 2"
                :errors="validationErrors"
              ></validation-errors>

              <el-form
                id="step2Form"
                ref="step2Form"
                :model="step2Form.form"
                :rules="step2FormRules"
                autocomplete="false"
                @submit.native.prevent
                @validate="handleFormFieldInput('step2Form')"
              >
                <h1 class="se-heading-m step-title">
                  <span class="color-primary">Step {{ currentStep }} / 3</span>
                  Profile and settings
                </h1>

                <el-row>
                  <el-col 
                    :md="24"
                    :lg="14"
                  >
                    <p class="se-body-l-screen mb-4">
                      In this section you can add what type of support you can offer other services and also what you’d like to get from Community Wealth Builder
                    </p>
                  </el-col>
                </el-row>

                <div class="step-hr mt-4"></div>

                <el-row>
                  <el-col
                    :md="24"
                    :lg="14"
                  >
                    <label for="about_organisation">
                      About your organisation and why it’s joining the network<span class="is-custom-asterisk">*</span><br />
                      <p class="el-form-item__info">Give other members some info about your organisation, what you offer and what you want from the network</p>
                      <span
                        class="sr-only"
                        aria-live="polite"
                        :hidden="! hasInlineValidationErrorFor('step2Form','about_organisation')"
                        v-text="getInlineValidationErrorFor('step2Form','about_organisation')"
                      ></span>
                    </label>
                    <el-form-item
                      prop="about_organisation"
                      class="is-no-asterisk"
                    >
                      <el-input
                        id="about_organisation"
                        v-model="step2Form.form.about_organisation"
                        type="textarea"
                        :rows="5"
                        maxlength="500"
                        label="Please give other members some info about your organisation, what you offer and what you want from the network in this field"
                        aria-required="true"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col
                    :md="24"
                    :lg="14"
                    class="mt-n4 mb-4"
                  >
                    <span class="se-body-l-screen color-light-gray">You have {{ 500 - step2Form.form.about_organisation.length }} characters remaining</span>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col
                    :md="24"
                    :lg="14"
                  >
                    <label for="experience">
                      About you and why you’re joining the network<span class="is-custom-asterisk">*</span><br />
                      <p class="el-form-item__info">Give other members some info about who you are e.g. what’s your background, skills, expertise and experience</p>
                      <span
                        class="sr-only"
                        aria-live="polite"
                        :hidden="! hasInlineValidationErrorFor('step2Form','experience')"
                        v-text="getInlineValidationErrorFor('step2Form','experience')"
                      ></span>
                    </label>
                    <el-form-item
                      prop="experience"
                      class="is-no-asterisk"
                    >
                      <el-input
                        id="experience"
                        v-model="step2Form.form.experience"
                        type="textarea"
                        :rows="5"
                        maxlength="500"
                        label="Please enter other activities in this field"
                        aria-required="true"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col
                    :md="24"
                    :lg="14"
                    class="mt-n4 mb-4"
                  >
                    <span class="se-body-l-screen color-light-gray">You have {{ 500 - step2Form.form.experience.length }} characters remaining</span>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col>
                    <label for="services">
                      Organisation services
                      <br />
                      <span
                        class="el-form-item__info"
                      >(You can select multiple options) </span>
                      <span
                        class="sr-only"
                        aria-live="polite"
                        :hidden="! hasInlineValidationErrorFor('step2Form', 'services')"
                        v-text="getInlineValidationErrorFor('step2Form', 'services')"
                      ></span>
                    </label>
                    <el-form-item
                      id="services"
                      prop="services"
                    >
                      <el-checkbox-group
                        v-model="step2Form.form.services"
                      >
                        <el-row>
                          <el-col
                            v-for="service in step2Form.services"
                            :key="service.id"
                            :xs="24"
                            :md="12"
                            :lg="8"
                            class="mb-3"
                          >
                            <el-checkbox
                              name="edit_service_id"
                              :label="service.id"
                            >
                              {{ service.name }}
                            </el-checkbox>
                          </el-col>
                        </el-row>
                      </el-checkbox-group>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col>
                    <label for="profile_visibility">
                      <span aria-hidden="true">Profile visibility</span><span class="is-custom-asterisk">*</span><br />
                      <span class="sr-only">Please select your profile visibility</span>
                      <span
                        class="sr-only"
                        aria-live="polite"
                        :hidden="! hasInlineValidationErrorFor('step2Form','profile_visibility')"
                        v-text="getInlineValidationErrorFor('step2Form','profile_visibility')"
                      ></span>
                    </label>
                  
                    <el-form-item
                      prop="profile_visibility"
                      class="mt-3"
                    >
                      <el-radio-group
                        v-model="step2Form.form.profile_visibility"
                        aria-label="select your profile visibility"
                      >
                        <el-radio
                          :label="1"
                          class="mb-2"
                        >
                          Allow Doncaster residents to find and contact you on the <a
                            :href="getBeWellDoncasterPageUrl"
                            target="_blank"
                          >Be Well Doncaster website</a>
                        </el-radio>
                        <el-radio :label="0">
                          Don't allow Doncaster residents to find and contact you on the <a
                            :href="getBeWellDoncasterPageUrl"
                            target="_blank"
                          >Be Well Doncaster website</a>
                        </el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <label for="resident_services">
                      <span aria-hidden="true">Resident services</span><span class="is-custom-asterisk">*</span>
                      <p class="el-form-item__info">Please select which of the following services you can offer to the residents of Doncaster. These will be used to help them find you on the BeWell website.</p>
                      <p class="el-form-item__info">(You can select multiple options)</p>
                      <span class="sr-only">Please select one or more resident service</span>
                      <span
                        class="sr-only"
                        aria-live="polite"
                        :hidden="! hasInlineValidationErrorFor('step2Form','resident_services')"
                        v-text="getInlineValidationErrorFor('step2Form','resident_services')"
                      ></span>
                    </label>
                    <el-form-item
                      id="resident_services"
                      prop="resident_services"
                    >
                      <el-checkbox-group
                        v-model="step2Form.form.resident_services"
                      >
                        <el-row>
                          <el-col
                            v-for="residentService in step2Form.residentServices"
                            :key="residentService.id"
                            :md="24"
                            :lg="24"
                            class="mb-3"
                          >
                            <el-checkbox
                              name="edit_expertise_id"
                              :label="residentService.id"
                            >
                              {{ residentService.name }}
                            </el-checkbox>
                          </el-col>
                        </el-row>
                      </el-checkbox-group>
                    </el-form-item>
                  </el-col>
                </el-row>  
                <el-row>
                  <el-col>
                    <label for="expertises">
                      <span aria-hidden="true">Expertise</span><span class="is-custom-asterisk">*</span>
                      <p class="el-form-item__info">(You can select multiple options)</p>
                      <span class="sr-only">Please select one or more Expertise</span>
                      <span
                        class="sr-only"
                        aria-live="polite"
                        :hidden="! hasInlineValidationErrorFor('step2Form','expertises')"
                        v-text="getInlineValidationErrorFor('step2Form','expertises')"
                      ></span>
                    </label>
                    <el-form-item
                      id="expertises"
                      prop="expertises"
                    >
                      <el-checkbox-group
                        v-model="step2Form.form.expertises"
                      >
                        <el-row>
                          <el-col
                            v-for="expertise in step2Form.expertises"
                            :key="expertise.id"
                            :xs="24"
                            :md="12"
                            :lg="8"
                            class="mb-3"
                          >
                            <el-checkbox
                              name="edit_expertise_id"
                              :label="expertise.id"
                            >
                              {{ expertise.name }}
                            </el-checkbox>
                          </el-col>
                        </el-row>
                      </el-checkbox-group>
                    </el-form-item>
                  </el-col>
                </el-row>   
                
                <el-row>
                  <el-col>
                    <label for="localities">
                      <span aria-hidden="true">Localities</span><span class="is-custom-asterisk">*</span><br />
                      <p class="mt-3 el-form-item__info font-weight-bold">Which regions of Doncaster does your organisation operate in?</p>
                      <p class="el-form-item__info mt-0">(Select multiple, if required)</p>
                      <span class="sr-only">Please select one or more localities</span>
                      <span
                        class="sr-only"
                        aria-live="polite"
                        :hidden="! hasInlineValidationErrorFor('step2Form','localities')"
                        v-text="getInlineValidationErrorFor('step2Form','localities')"
                      ></span>
                    </label>
                    
                    <el-form-item
                      id="localities"
                      prop="localities"
                    >
                      <el-checkbox-group
                        v-model="step2Form.form.localities"
                      >
                        <el-row>
                          <el-col
                            v-for="localitiy in step2Form.localities"
                            :key="localitiy.id"
                            class="mb-3"
                          >
                            <el-checkbox
                              name="edit_expertise_id"
                              :label="localitiy.id"
                            >
                              {{ localitiy.name }}
                            </el-checkbox>
                          </el-col>
                        </el-row>
                      </el-checkbox-group>
                    </el-form-item>
                  </el-col>
                </el-row> 
                <div class="step-hr"></div>  
                <el-row>
                  <el-col>
                    <label for="terms_agreed">
                      <span
                        class="sr-only"
                        aria-live="polite"
                        :hidden="! hasInlineValidationErrorFor('step2Form','privacy_agreed')"
                        v-text="getInlineValidationErrorFor('step2Form','privacy_agreed')"
                      ></span>
                    </label>
                    <el-form-item
                      id="privacy_agreed"
                      prop="privacy_agreed"
                      class="mb-0"
                    >
                      <el-checkbox-group v-model="step2Form.form.privacy_agreed">
                        <el-checkbox
                          label="privacy_agreed_confirmed"
                          :value="0"
                          class="mb-3"
                        >
                          I acknowledge that I have read and understand the <router-link
                            :to="{ name: 'Cookie Policy' }"
                            class="text__link"
                            target="_blank"
                          >
                            privacy policy
                          </router-link>
                        </el-checkbox>
                      </el-checkbox-group>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col
                    class="mb-5"
                  >
                    <label for="terms_agreed">
                      <span
                        class="sr-only"
                        aria-live="polite"
                        :hidden="! hasInlineValidationErrorFor('step2Form','terms_agreed')"
                        v-text="getInlineValidationErrorFor('step2Form','terms_agreed')"
                      ></span>
                    </label>
                    <el-form-item
                      id="terms_agreed"
                      prop="terms_agreed"
                    >
                      <el-checkbox-group v-model="step2Form.form.terms_agreed">
                        <el-checkbox
                          label="terms_agreed_confirmed"
                          :value="1"
                        >
                          I acknowledge that I have read and understand the <router-link
                            :to="{ name: 'Terms & Conditions' }"
                            class="text__link"
                            target="_blank"
                          >
                            terms and conditions
                          </router-link>
                          for use of this site
                        </el-checkbox>
                      </el-checkbox-group>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>

              <div class="submit-button-wrapper mt-4">
                <el-button
                  type="primary"
                  native-type="submit"
                  @click="submitStep2Form"
                >
                  Complete registration
                </el-button>
              </div>
            </div>
            <!-- Step 2 Plans and experience End -->
            <!-- Step 4 Verify your account -->
            <div
              v-show="currentStep === 4"
              class="body__content"
            >
              <h1 class="se-heading-xl-40 mb-4">
                Thanks for submitting your application
              </h1>
              <el-row>
                <el-col>
                  <p class="se-body-l-screen-19 mb-4">
                    We’ve sent you an email confirmation. We’ll review the information you’ve provided and let you know within 3 days whether or not your application has been approved. In the meantime, we might need to get in touch if we need more information.
                  </p>
                  <p class="se-body-l-screen-19 mb-4">
                    If you need to speak to us about your application, <a
                      :href="getBeWellDoncasterPageUrl('/for-my-organisation/contact-us-cwb')"
                      class="text__link"
                    >
                      just get in touch
                    </a>. <br />
                  </p>
                  <el-button
                    type="primary"
                    native-type="submit"
                    @click="gotoLink('/login')"
                  >
                    Back to Login
                  </el-button>
                </el-col>
              </el-row>
            </div>
            <!-- Step 4 Verify your account End -->
          </el-col>
        </el-row>
      </div>
    </div>

    <cropper-upload
      v-if="cropperFile"
      :visible="showCropperDialog"
      :cropper-file="cropperFile"
      @upload="onCropperUpload"
      @close="onCropperDialogClose"
    ></cropper-upload>
  </div>
</template>

<script>
import gsApi from '@/services/gs.api'
import loqateApi from '@/services/loqate.api'
import { validateWebsiteAddress, validateEmail, validateContactNumber} from '@/helpers/validators'
import CropperUpload from '@/components/cropper-upload/cropper-upload'
import validationErrors from '@/components/partials/validation-errors'

export default {
  name: 'SignupNgs',
  metaInfo: {
    title: "Apply to become a service on CWB",
    meta: [{
      name: 'description',
      content: "Are you a successful business person with connections to Scotland and keen to offer your expertise to Scottish businesses? Apply to become a service on CWB today."
    }]
  },
  components: {
    validationErrors,
    'cropper-upload': CropperUpload,
  },
  data :function() {

    const validateEmailConfirmation = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Email address doesn’t match. Make sure the email address in both email fields match.'))
      } else if (value !== this.step1Form.form.email) {
        callback(new Error("Email address doesn’t match. Make sure the email address in both email fields match."))
      } else {
        callback()
      }
    }

    return {
      validationErrors: [],
      mainLoader: false,
      currentStep: 1,
      cropperFile: null,
      showCropperDialog: false,
      step1Form: { // Step 1
        form: {
          first_name: '',
          last_name: '',
          email:'',
          email_confirmation:'',
          organisation_photo: null,
          name:'',
          address_1: '',
          address_2: '',
          post_code: '',
          town: '',
          county: '',
          contact_number: '',
          organisation_email: '',
          website_address:'',
          organisation_name:''
        },
        addressesLoading: false,
        disableAddressLookup: false,
        inlineValidationErrors: [],
        availableMailingAddresses: [],
        selectedAvailableMailingAddress: null,
        avatarFile: null
      },
      step1FormRules: {
        first_name: [
          { required: true, message: 'Enter your first name', trigger: 'blur' },
          { max: 64, message: 'First name may not be greater than 64 characters', trigger: 'blur' },
        ],
        last_name: [
          { required: true, message: 'Enter your last name', trigger: 'blur' },
          { max: 64, message: 'Last name may not be greater than 64 characters', trigger: 'blur' },
        ],
        email: [
          { validator: validateEmail, required: true },
        ],
        email_confirmation: [
          { validator: validateEmailConfirmation, required: true },
        ],
        name: [
          { required: true, message: 'Enter your organisation name', trigger: 'blur' },
          { max: 64, message: 'organisation may not be greater than 64 characters', trigger: 'blur' }
        ],
        contact_number: [
          { required: false, validator: validateContactNumber },
        ],
        post_code: [
          { required: true, message: 'Enter a postcode', trigger: 'blur' },
          { max: 10, message: 'Postcode may not be greater than 10 characters', trigger: 'blur' },
        ],
        address_1: [
          { required: true, message: 'Enter the first line of your address', trigger: 'blur' },
          { max: 255, message: 'Address line 1 may not be greater than 255 characters', trigger: 'blur' },
        ],
        address_2: [
          { max: 255, message: 'Address line 2 may not be greater than 255 characters', trigger: 'blur' },
        ],
        town: [
          { required: true, message: 'Enter a town or city', trigger: 'blur' },
          { max: 100, message: 'Town or City may not be greater than 100 characters', trigger: 'blur' },
        ],
        county: [
          { required: true, message: 'Enter a county', trigger: 'blur' },
          { max: 100, message: 'County may not be greater than 100 characters', trigger: 'blur' },
        ],
        organisation_name: [
          { required: true, message: 'Enter an organisation name', trigger: 'blur' },
          { max: 255, message: 'Organisation name may not be greater than 255 characters', trigger: 'blur' },
        ],
        website_address: [
          { required: false, validator: validateWebsiteAddress },
        ],
        organisation_email: [
          { required: false, validator: validateEmail },
        ],
      },
      step2Form: { // Step 2
        form: {
          about_organisation:"",
          experience: '',
          profile_visibility: 1,
          services: [],
          resident_services:[],
          expertises: [],
          localities:[],
          privacy_agreed: [],
          terms_agreed:[]
        },
        services: [],
        expertises: [],
        localities:[],
        residentServices:[],
        inlineValidationErrors: [],
      },
      step2FormRules: {
        about_organisation: [
          { required: true, message: 'Tell us more about your organisation', trigger: 'blur' },
          { max: 500, message: 'about organisation may not be greater than 500 characters', trigger: 'change' },
        ],
        experience: [
          { required: true, message: 'Tell us more about you', trigger: 'blur' },
          { max: 500, message: 'experience may not be greater than 500 characters', trigger: 'change' },
        ],
        services: [
          { type: 'array', required: true, message: 'Select a services of business from the dropdown', trigger: 'change' }
        ],
        expertises: [
          { type: 'array', required: true, message: 'Select an expertises of business from the dropdown', trigger: 'change' }
        ],
        localities: [
          { type: 'array', required: true, message: 'Select a localities of business from the dropdown', trigger: 'change' }
        ],
        resident_services:[
          { type: 'array', required: true, message: 'Select a resident service for your organisation from the dropdown', trigger: 'change' }
        ],
        privacy_agreed: [
          { type: 'array', required: true, message: 'Check the box to confirm you agree to our privacy policy.', trigger: 'change' },
        ],
        terms_agreed: [
          { type: 'array', required: true, message: 'Check the box to confirm you agree to our terms and conditions.', trigger: 'change' },
        ],
      },
    }
  },
  computed: {
    heroText: function() {
      if(this.currentStep == 1) return '"Community Wealth Builders are people who want to give something back and I\'m delighted to be a part of that." <p class="mt-1">Community Wealth Builder Allan Rooney</p>'
      else if(this.currentStep == 2)  return '"Community Wealth Builder has had such a huge impact on our business - frankly, it could have been the difference between us making it or not." <p class="mt-1">David Capaldi, Opinurate</p>'
      else return "Application complete! We’ll let you know soon."
    },
    avatarUrl: function () {
      return this.step1Form.avatarFile.url
    },
    getBeWellDoncasterPageUrl(){
      return ( page = null) => {
        return `${process.env.VUE_APP_BE_WELL_CMS_URL}${page ? page : ''}`
      }
    }
  },
  created() {
    this.getRegisterMeta()
  },
  methods: {
    submitStep1Form() {
      this.$refs['step1Form'].validate((valid) => {
        if (valid) {

          const formData = new FormData()
          formData.append('is_organisation',1)
          formData.append('first_name', this.$options.filters.domPurify(this.step1Form.form.first_name, {ALLOWED_TAGS: []}))
          formData.append('last_name', this.$options.filters.domPurify(this.step1Form.form.last_name, {ALLOWED_TAGS: []}))
          formData.append('email', this.step1Form.form.email)
          formData.append('email_confirmation', this.step1Form.form.email_confirmation)
          
          formData.append('organisation_name', this.step1Form.form.organisation_name)
          formData.append('role', this.step1Form.form.role)
          formData.append('organisation_email', this.step1Form.form.organisation_email)
          formData.append('contact_number', this.step1Form.form.contact_number)
          formData.append('address_1', this.step1Form.form.address_1)
          formData.append('address_2', this.step1Form.form.address_2)
          formData.append('post_code', this.step1Form.form.post_code)
          formData.append('town', this.step1Form.form.town)
          formData.append('county', this.step1Form.form.county)
          formData.append('website_address', this.step1Form.form.website_address)

          if (this.step1Form.form.organisation_photo) {
            formData.append("organisation_photo", this.step1Form.form.organisation_photo)
          }

          this.mainLoader = true

          gsApi.globalscot.validateStepOne(formData)
            .then(() => {
              this.validationErrors = [];
              this.gotoStep(2)
            })
            .catch(error => {
              this.validationErrors = [];
              if (error.response && error.response.status == 422 && error.response.data) {
                let errors = error.response.data.errors;
                
                for (let [key, value] of Object.entries(errors)) {
                  
                  let obj = {}
                  obj.id = key;
                  obj.message = value[0];
                  this.validationErrors.push(obj);
                }
                window.scrollTo({top: 0, behavior: 'smooth'});
              } else {
                this.$alert('There are errors in the form, please fix these errors and try again.', 'Error', { confirmButtonText: 'Close', showClose: false, customClass: 'notification-modal' });
              }
            }).finally(()=>{
              this.mainLoader = false
            })
        } else {
          this.validationErrors = [];
          this.$refs.step1Form.fields.forEach(field => {
            if(field.validateState == 'error') {
              let obj = {}
              obj.id = field.labelFor;
              obj.message = field.validateMessage;
              this.validationErrors.push(obj);
            }
          });
          this.$nextTick(() => {
            document.getElementById('formErrorBlock').scrollIntoView({ behavior: 'smooth', block: 'start' })
            let text = document.getElementById("step1Form").getElementsByClassName('el-form-item__error')[0].textContent
            this.$announcer.set(text)
          })
        }
      });
    },
    submitStep2Form() {
      this.$refs['step2Form'].validate((valid) => {
        if (valid) {
          const formData = new FormData()

          // Step 1
          formData.append('is_organisation',1)
          formData.append('first_name', this.$options.filters.domPurify(this.step1Form.form.first_name, {ALLOWED_TAGS: []}))
          formData.append('last_name', this.$options.filters.domPurify(this.step1Form.form.last_name, {ALLOWED_TAGS: []}))
          formData.append('email', this.step1Form.form.email)
          formData.append('email_confirmation', this.step1Form.form.email_confirmation)
          
          //formData.append('organisation', []);
          formData.append('organisation_name', this.step1Form.form.organisation_name)
          formData.append('role', this.step1Form.form.role)
          formData.append('organisation_email', this.step1Form.form.organisation_email)
          formData.append('contact_number', this.step1Form.form.contact_number)
          formData.append('address_1', this.step1Form.form.address_1)
          formData.append('address_2', this.step1Form.form.address_2)
          formData.append('post_code', this.step1Form.form.post_code)
          formData.append('town', this.step1Form.form.town)
          formData.append('county', this.step1Form.form.county)
          formData.append('website_address', this.step1Form.form.website_address)
          formData.append('profile_visibility', this.step2Form.form.profile_visibility)
          formData.append('about_organisation', this.step2Form.form.about_organisation)

          if (this.step1Form.form.organisation_photo) {
            formData.append("organisation_photo", this.step1Form.form.organisation_photo)
          }

          // Step 2
          formData.append('experience', this.step2Form.form.experience)
          
          formData.append('services', [])
          this.step2Form.form.services.forEach((service) => {
            formData.append('services[]', service)
          })

          formData.append('resident_services', [])
          this.step2Form.form.resident_services.forEach((resident_service) => {
            formData.append('resident_services[]', resident_service)
          })

          formData.append('localities', [])
          this.step2Form.form.localities.forEach((locality) => {
            formData.append('localities[]', locality)
          })

          formData.append('expertises', [])
          this.step2Form.form.expertises.forEach((expertise) => {
            formData.append('expertises[]', expertise)
          })

          this.mainLoader = true

          gsApi.globalscot.register(formData)
            .then(() => {
              this.validationErrors = []
              this.mainLoader = false
              this.gotoStep(4)
            })
            .catch(error => {
              this.validationErrors = [];
              this.mainLoader = false

              if (error.response && error.response.status == 422 && error.response.data) {
                let errors = error.response.data.errors;
                for (let [key, value] of Object.entries(errors)) {
                  let obj = {}
                  obj.id = key;
                  obj.message = value[0];
                  this.validationErrors.push(obj);
                }
                window.scrollTo({top: 0, behavior: 'smooth'});
              } else {
                this.$alert('There are errors in the form, please fix these errors and try again.', 'Error', { confirmButtonText: 'Close', showClose: false, customClass: 'notification-modal' });
              }
            })
        } else {
          this.validationErrors = [];
          this.$refs.step2Form.fields.forEach(field => {
            if(field.validateState == 'error') {
              let obj = {}
              obj.id = field.labelFor;
              obj.message = field.validateMessage;
              this.validationErrors.push(obj);
            }
          });
          this.$nextTick(() => {
            document.getElementById('formErrorBlock').scrollIntoView({ behavior: 'smooth', block: 'start' })
            let text = document.getElementById("step2Form").getElementsByClassName('el-form-item__error')[0].textContent
            this.$announcer.set(text)
          })
        }
      });
    },
    onFindAddress (e) {
      this.findAddresses(this.step1Form.form.post_code)
    },
    findAddresses (value, country_id='') {
      this.step1Form.addressesLoading = true
      loqateApi.find(value, country_id, '')
        .then(response => {

          if (response.data && response.data.Items && response.data.Items.length > 0) {
            if (response.data.Items[0].Error) {
              this.$alert('Failed to find any addresses using postcode provided. Please enter mailing address details instead.', 'No addresses found', { confirmButtonText: 'Close', showClose: false, customClass: 'notification-modal' });
            } else if (response.data.Items[0].Type != "Address") {
              this.findAddresses(value, response.data.Items[0].Id)
            } else if (!response.data.Items[0].Error) {
              this.step1Form.disableAddressLookup = true
              this.step1Form.availableMailingAddresses = response.data.Items
            }
          } else {
            this.$alert('Failed to find any addresses using postcode provided. Please enter mailing address details instead.', 'No addresses found', { confirmButtonText: 'Close', showClose: false, customClass: 'notification-modal' });
          }
        })
        .catch(() => {
        
          this.$alert('Failed to find any addresses using postcode provided. Please enter mailing address details instead.', 'No addresses found', { confirmButtonText: 'Close', showClose: false, customClass: 'notification-modal' });
        }).finally(()=>{
          this.step1Form.addressesLoading = false
        })
    },
    onAvailableMailingAddressSelected (address) {
      this.retrieveAddress(address.Id);
    },
    retrieveAddress (id) {
      loqateApi.retrieve(id)
        .then(response => {
          if (response.data && response.data.Items && response.data.Items.length > 0 && !response.data.Items[0].Error) {
            this.step1Form.disableAddressLookup = true

            let address = response.data.Items[0]
            this.step1Form.form.address_1 = address.Line1
            this.step1Form.form.address_2 = address.Line2
            this.step1Form.form.post_code = address.PostalCode
            this.step1Form.form.town = address.City
            this.step1Form.form.county = address.AdminAreaName

          } else {
            this.$alert('Failed to automatically use the selected address. Please enter mailing address details instead.', 'Warning', { confirmButtonText: 'Close', showClose: false, customClass: 'notification-modal' });
          }
        })
        .catch(error => {
          this.$alert('Failed to automatically use the selected address. Please enter mailing address details instead.', 'Warning', { confirmButtonText: 'Close', showClose: false, customClass: 'notification-modal' });
        })
    },
    // Start of upload / cropper methods
    onFileChange(file) {
      if (this.validateOrganisationPhotoUpload(file)) {
        this.cropperFile = file
        this.showCropperDialog = true
      }
    },
    onCropperUpload(croppedFileData) {
      
      this.step1Form.avatarFile = croppedFileData
      this.step1Form.form.organisation_photo = croppedFileData.file
      this.onCropperDialogClose()
    },
    onCropperDialogClose() {
      this.showCropperDialog = false
      this.cropperFile = null
    },
    removeSelectedAvatar() {
      this.step1Form.avatarFile = null
      this.step1Form.form.organisation_photo = null
      this.cropperFile = null
      this.$refs.upload.clearFiles()
    },
    validateOrganisationPhotoUpload(file) {
      let type = (file.raw && file.raw.type) ? file.raw.type : file.type
      let size = (file.raw && file.raw.size) ? file.raw.size : file.size

      const isJPG = type === 'image/jpeg';
      const isPNG = type === 'image/png';
      const isLt10M = size / 1024 / 1024 <= 10;

      if (!isJPG && !isPNG) {
        this.$alert('Avatar must be in a jpeg or png format.', 'Error', { confirmButtonText: 'Close', showClose: false, customClass: 'notification-modal' });
      } else if (!isLt10M) {
        this.$alert('Avatar size can not exceed 6MB.', 'Error', { confirmButtonText: 'Close', showClose: false, customClass: 'notification-modal' });
      }

      return (isJPG || isPNG) && isLt10M;
    },
    getRegisterMeta() 
    {
      this.mainLoader = true

      gsApi.globalscot.meta.index()
        .then(response => {
          this.mainLoader = false

          this.step2Form.services = response.data.services.data
          this.step2Form.expertises = response.data.expertises.data
          this.step2Form.localities = response.data.localities.data,
          this.step2Form.residentServices = response.data.residentServices.data

        }).catch(error => {
          this.mainLoader = false
          this.$alert('An unknown error occurred. Please try again later.', 'Error', { confirmButtonText: 'Close', showClose: false, customClass: 'notification-modal' });
          this.gotoLink('/home')
        })
    },
    gotoStep(step) {
      this.currentStep = step
      if (this.currentStep == 1) {
        this.$announcer.set('Step 1 of 3 - Personal and company details')
      } else if (this.currentStep == 2) {
        this.$announcer.set('Step 2 of 3 - Plans and experience')
      }
      window.scrollTo(0,0)
    },
    gotoLink(link) {
      this.$router.push(link)
    },
    handleFormFieldInput(formName) {
      this[formName].inlineValidationErrors = [];
      this.$refs[formName].fields.forEach(field => {
        if (field.validateState === 'error') {
          let obj = {};
          obj.id = field.labelFor;
          obj.message = field.validateMessage;
          this[formName].inlineValidationErrors.push(obj);
        }
      });
    },
    hasInlineValidationErrorFor(formName, fieldName) {
      return this.getInlineValidationErrorFor(formName, fieldName).length > 0;
    },
    getInlineValidationErrorFor(formName, fieldName) {
      const validationError = this[formName].inlineValidationErrors.find(error => error.id === fieldName);
      if (! validationError) {
        return '';
      }

      return validationError.message;
    },
  },
}
</script>

<style>
  .step-1-avatar img {
    width: 140px;
    height: 140px;
  }
</style>
